// Mock data for Mind'UP website

export const testimonials = [
  {
    id: 1,
    name: "Samar",
    role: "Femme au foyer",
    location: "Strasbourg",
    image: "https://images.unsplash.com/photo-1625987306773-8b9e554b25e2",
    quote: "Je n'ai pas eu à expliquer pourquoi un simple appel familial pouvait me vider de mon énergie. Elle le comprenait. Elle m'a appris à poser des frontières avec grâce, sans trahir mon amour vers eux parce que j'ai commencé à voir les choses différemment et souhaitais si seulement ils pouvaient les voir aussi de face.",
    category: "personal"
  },
  {
    id: 2,
    name: "Sarah",
    role: "Consultante",
    location: "Genève",
    image: "https://images.pexels.com/photos/34225151/pexels-photo-34225151.jpeg",
    quote: "M'a aidée à réconcilier la femme d'affaires que je suis devenue avec la jeune fille que j'ai toujours été. Cette légèreté retrouvée est si précieuse — je ne la connaissais pas et je ne voudrais plus jamais la perdre.",
    category: "business"
  },
  {
    id: 3,
    name: "Amani",
    role: "Nouvelle Maman",
    location: "Karlsruhe",
    image: "https://images.pexels.com/photos/1036622/pexels-photo-1036622.jpeg",
    quote: "Le post-partum en Allemagne, loin de ma famille, était un désert. Sanaa a été mon oasis. Elle a compris ma solitude sans un mot, m'a accompagnée avec tant de douceur et de compréhension. Elle savait exactement ce que je traversais.",
    category: "maternity"
  },
  {
    id: 4,
    name: "Leila",
    role: "Directrice",
    location: "Zurich",
    image: "https://images.unsplash.com/photo-1521511189395-b82252213754",
    quote: "Son approche systémique m'a aidée à gérer mon équipe multiculturelle avec une empathie et une efficacité que je ne pensais pas possibles. Je dirige maintenant avec mon cœur autant qu'avec ma tête.",
    category: "leadership"
  }
];

export const pricingOptions = [
  {
    id: 1,
    type: "Séance Individuelle",
    priceEUR: "À partir de 170€",
    priceMAD: "1500 MAD", 
    priceAED: "600 AED",
    duration: "90 minutes",
    description: "Session individuelle personnalisée selon ton contexte et tes besoins culturels spécifiques",
    features: [
      "Approche interculturelle personnalisée",
      "Outils systémiques adaptés à ta réalité",
      "Support entre les séances par email",
      "Matériel pédagogique inclus en 3 langues",
      "Confidentialité absolue garantie"
    ]
  },
  {
    id: 2,
    type: "Programme Transformation",
    priceEUR: "Sur mesure",
    duration: "6-10 séances",
    description: "Accompagnement complet pour une transformation profonde et durable de ta vie",
    features: [
      "Bilan initial approfondi interculturel",
      "Plan de développement personnalisé", 
      "Suivi régulier et ajustements",
      "Outils d'autonomisation à vie",
      "Support prioritaire et urgences",
      "Séance de suivi gratuite après 6 mois"
    ]
  },
  {
    id: 3,
    type: "Accompagnement Maternité",
    priceEUR: "Programme spécialisé",
    duration: "Selon besoins",
    description: "Support spécialisé grossesse, post-partum et maternité interculturelle avec compréhension culturelle profonde",
    features: [
      "Préparation psychologique à la maternité",
      "Accompagnement post-naissance spécialisé", 
      "Gestion de la charge mentale maternelle",
      "Support familial et conjugal",
      "Flexibilité horaires et urgences",
      "Groupe de soutien entre mammes (optionnel)"
    ]
  }
];

export const contactInfo = {
  email: "contact@mindup-coaching.com",
  phone: "+49 160-959-138-42",
  locations: [
    "Consultation en ligne sécurisée (FR/DE/AR)",
    " Déplacements possibles"
  ],
  languages: ["Français", "Deutsch", "العربية"],
  socialMedia: {
    linkedin: "https://linkedin.com/in/sanaa-ait-balla",
    instagram: "@mindup_coaching"
  }
};

export const faqs = [
  {
    id: 1,
    question: "Quelle est la différence entre coaching et thérapie ?",
    answer: "Le coaching se concentre sur l'atteinte d'objectifs futurs et le développement de ton potentiel, tandis que la thérapie traite principalement les blessures du passé. Mon approche coaching t'aide à créer la vie que tu souhaites en partant de tes ressources actuelles."
  },
  {
    id: 2,
    question: "Pourquoi choisir un coaching interculturel spécialisé ?",
    answer: "Parce que ta réalité multiculturelle est une richesse, pas un obstacle. Je comprends intimement les défis spécifiques aux femmes qui naviguent entre plusieurs cultures, langues et systèmes de valeurs. Cette expertise unique permet un accompagnement authentique et profond."
  },
  {
    id: 3,
    question: "Comment se déroule la première séance découverte ?",
    answer: "Nous commençons par 30 minutes de conversation authentique pour faire vraiment connaissance, comprendre tes défis et clarifier tes besoins. C'est un moment d'écoute pure, sans jugement, dans la langue de ton choix. Aucun engagement n'est requis."
  },
  {
    id: 4,
    question: "Les séances peuvent-elles vraiment se faire en arabe ?",
    answer: "Absolument. Je propose mes services en français, allemand et arabe, avec une compréhension profonde des nuances culturelles et émotionnelles de chaque langue. Nous travaillons dans la langue où tu te sens la plus authentique."
  },
  {
    id: 5,
    question: "Combien de séances sont généralement nécessaires ?",
    answer: "Cela dépend entièrement de tes objectifs et de ton rythme. Généralement, un accompagnement efficace nécessite 6 à 10 séances, espacées de 2 à 3 semaines pour permettre l'intégration profonde. Certaines transformations se font plus rapidement, d'autres demandent plus de temps - nous nous adaptons à ta réalité."
  }
];